import {
  TConfigItemType,
  TVerificationAppFieldConfigItem,
} from "../../../app/models";

export const PASSPORT_FIELDS: TVerificationAppFieldConfigItem[] = [
  { name: "first_name", label: "First Name", type: TConfigItemType.TEXT },
  { name: "last_name", label: "Last Name", type: TConfigItemType.TEXT },
  { name: "middle_name", label: "Middle Name", type: TConfigItemType.TEXT },
  {
    name: "date_of_birth",
    label: "Date Of Birth",
    type: TConfigItemType.DATE,
  },
  { name: "place_of_origin", label: "Place Of Origin", type: TConfigItemType.TEXT },
  { name: "country", label: "Country", type: TConfigItemType.COUNTRY_SELECT },
  {
    name: "gender",
    label: "Gender",
    type: TConfigItemType.SELECT,
    data: [
      { label: "Female", value: "Female" },
      { label: "Male", value: "Male" },
    ],
  },
  { name: "identifier", label: "Identifier", type: TConfigItemType.TEXT },
  { name: "issued_by", label: "Issued By", type: TConfigItemType.TEXT },
  { name: "issued_at", label: "Issued At", type: TConfigItemType.DATE },
  { name: "expired_at", label: "Expired At", type: TConfigItemType.DATE },
];

export const ID_FIELDS: TVerificationAppFieldConfigItem[] = [
  ...PASSPORT_FIELDS,
  { name: "number", label: "Number", type: TConfigItemType.TEXT },
];

export const IDENTIFICATION_DOCUMENT_FILE_FIELD: TVerificationAppFieldConfigItem = {
  name: "document",
  label: "Document files",
  type: TConfigItemType.FILE_PICKER,
  multiple: true,
};

export const DOCUMENT_TYPE_FIELDS: Record<
  string,
  TVerificationAppFieldConfigItem[]
> = {
  Passport: PASSPORT_FIELDS,
  Id: ID_FIELDS,
};
